import axios from "axios";
import { baseURL } from "../utils/URL";

const onAddLeaveType = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/leave/type`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
const onUpdateLeaveType = async (id:any, postData:any ,config: any) => {
    try {
      const response = await axios.patch(`${baseURL}/leave/type/${id}`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
 




const onAddLeavePolicy = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/leave/policy`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };


const onAddLeaveRequest = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/leave`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };



  const ongetOrgLeaveTypes = async (id:any,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/leave/type/organization/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

  const HandleLeaveReq =async(postdata:any, config:any)=>{
    try {
      const response = await axios.post(`${baseURL}/leave/handle`, postdata,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }

  }
  const CancelLeaveReq =async(postdata:any, config:any)=>{
    try {
      const response = await axios.patch(`${baseURL}/leave/cancel`, postdata,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }

  }
  
  const ongetOrgLeavePolicies = async (id:any,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/leave/policy/organization/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

  const ongetOrgLeaves = async (id:any,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/leave/organization/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

  const ongetEmplLeaves = async (id:any,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/leave/employee/${id}`,config);
      return response.data;
    } catch (error: any) {
      
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };


  const onDeleteLeaveType = async (id:any,config: any) => {
    try {
      const response = await axios.delete(`${baseURL}/leave/type/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
  export{onAddLeaveType, CancelLeaveReq,HandleLeaveReq, onAddLeaveRequest, ongetEmplLeaves, ongetOrgLeaves, onUpdateLeaveType ,ongetOrgLeavePolicies,  onAddLeavePolicy,ongetOrgLeaveTypes, onDeleteLeaveType}